const SUPPORT_WHATSAPP_NUMBER = "584245828614";

export const buildSupportWhatsAppUrl = (message) =>
  `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(
    message
  )}`;
